import { LoadablePaint } from '@confluence/loadable';

export const ShareableLinkSiteAdminConfigurationLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkSiteConfiguration" */ './components/SiteConfigPage.tsx'
			)
		).SiteConfigPage,
});
